import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

// Definition ID: def:rosta:hr:page-description
export interface PageDescriptionProps {
  entity: string;
  description: string;
  icon?: React.ReactNode;
}

export function PageDescription({ entity, description, icon }: PageDescriptionProps) {
  return (
    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
      {icon && <Box sx={{ color: 'info.main', fontSize: 28, display: 'flex' }}>{icon}</Box>}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography variant="h6" fontWeight={600} color="info.main">
          {entity}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
